export default __webpack_public_path__ + "static/media/community-leader-badge.3148a0ed.png";